var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ib-card',{staticClass:"owners-share-card d-flex flex-column py-3",attrs:{"animation":false}},[(!_vm.isEmpty)?_c('p',{staticClass:"m-0 text-center h4"},[_vm._v(" "+_vm._s(_vm.$t('pages.businessGuide.ownership.share'))+" ")]):_vm._e(),_c('div',[_c('owners-chart')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }